import { IDialog } from 'runtime/dialogs/dialog';

export class DialogRequested {
    constructor(public dialog: IDialog) { }

    static eventName() { return 'DialogRequested'; }

    eventName = DialogRequested.eventName;
}